"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Linkedin;
    }
});
var _react = /*#__PURE__*/ _interopRequireDefault(require("react"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function Linkedin(props) {
    var svgProps = Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 21 20",
        width: "21",
        height: "20",
        fill: "currentColor"
    }, props);
    return /*#__PURE__*/ _react.default.createElement("svg", _extends({}, svgProps), /*#__PURE__*/ _react.default.createElement("path", {
        d: "M19.625 0H1.375C0.875 0 0.5 0.375 0.5 0.875V19.25C0.5 19.625 0.875 20 1.375 20H19.75C20.25 20 20.625 19.625 20.625 19.125V0.875C20.5 0.375 20.125 0 19.625 0ZM6.375 17H3.5V7.5H6.5V17H6.375ZM5 6.25C4 6.25 3.25 5.375 3.25 4.5C3.25 3.5 4 2.75 5 2.75C6 2.75 6.75 3.5 6.75 4.5C6.625 5.375 5.875 6.25 5 6.25ZM17.5 17H14.5V12.375C14.5 11.25 14.5 9.875 13 9.875C11.5 9.875 11.25 11.125 11.25 12.375V17.125H8.25V7.5H11.125V8.75C11.5 8 12.5 7.25 13.875 7.25C16.875 7.25 17.375 9.25 17.375 11.75V17H17.5Z"
    }));
}

//# sourceMappingURL=Linkedin.js.map